import { FormControlLabel, MenuItem, Select } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { SkywardIntegrationTokenActions } from "../../../../models/IIntegrationSecuritySettingsUpdate";

const WideSelect = styled(Select)`
  min-width: 250px;
`;

export interface ITokenActionSelectProps {
  label: string;
  value: SkywardIntegrationTokenActions;
  disabled: boolean;
  hasToken: boolean;
  tokenHint: string | null;
  onChange: (value: SkywardIntegrationTokenActions) => void;
}

export const TokenActionSelect = (props: ITokenActionSelectProps): JSX.Element => {
  const { label, value, disabled, hasToken, tokenHint, onChange } = props;

  const options: Array<{ name: string; value: number }> = [];
  if (hasToken) {
    const hint: string = tokenHint === null ? "" : ` (${tokenHint}...)`;
    options.push({ name: `Keep current token${hint}`, value: SkywardIntegrationTokenActions.None });
    options.push({ name: "Revoke this token", value: SkywardIntegrationTokenActions.Revoke });
    options.push({ name: "Generate a new token", value: SkywardIntegrationTokenActions.Generate });
  } else {
    options.push({ name: "Leave this token inactive", value: SkywardIntegrationTokenActions.None });
    options.push({ name: "Generate a new token", value: SkywardIntegrationTokenActions.Generate });
  }

  const onValueChange = (value: unknown): void => {
    if (typeof value === "number" && value in SkywardIntegrationTokenActions) {
      onChange(value);
    } else {
      onChange(SkywardIntegrationTokenActions.None);
    }
  };

  return (
    <FormControlLabel
      label={label}
      control={
        <WideSelect value={value} onChange={event => onValueChange(event.target.value)}>
          {options.map((option, key) => (
            <MenuItem key={key} value={option.value}>
              {option.name}
            </MenuItem>
          ))}
        </WideSelect>
      }
      disabled={disabled}
    />
  );
};
